var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", { ref: "form", attrs: { novalidate: "" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("section-title", {
            attrs: {
              "container-class": "tag-badge-main-info mt-4 mb-4",
              content: "VIII. Valores",
              icon: "fas fa-clipboard-list-check"
            }
          }),
          _c(
            "label",
            { staticClass: "text-muted", staticStyle: { "font-size": "14px" } },
            [
              _vm._v(
                " Según la O*NET los valores predominantes en esta ocupación son: "
              )
            ]
          ),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": [
                                "d-block",
                                "small-counter",
                                "text-right"
                              ],
                              "custom-error-msg": "Campo requerido",
                              disabled: _vm.isReadOnly,
                              error: errors[0],
                              label: "Independencia:",
                              maxlength: 5000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.selfReliance,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "selfReliance", $$v)
                              },
                              expression: "model.selfReliance"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4117982418
                )
              })
            : _c("div", { staticClass: "d-flex flex-column" }, [
                _c(
                  "label",
                  {
                    staticClass: "text-muted",
                    staticStyle: { "font-size": "14px" }
                  },
                  [_vm._v(" Independencia: ")]
                ),
                _c("span", [_vm._v(_vm._s(_vm.model.selfReliance))])
              ]),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": [
                                "d-block",
                                "small-counter",
                                "text-right"
                              ],
                              "custom-error-msg": "Campo requerido",
                              disabled: _vm.isReadOnly,
                              error: errors[0],
                              label: "Logros:",
                              maxlength: 5000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.achievements,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "achievements", $$v)
                              },
                              expression: "model.achievements"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2182531218
                )
              })
            : _c("div", { staticClass: "d-flex flex-column" }, [
                _c(
                  "label",
                  {
                    staticClass: "text-muted",
                    staticStyle: { "font-size": "14px" }
                  },
                  [_vm._v(" Logros: ")]
                ),
                _c("span", [_vm._v(_vm._s(_vm.model.achievements))])
              ]),
          !_vm.isReadOnly
            ? _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "count-classes": [
                                "d-block",
                                "small-counter",
                                "text-right"
                              ],
                              "custom-error-msg": "Campo requerido",
                              disabled: _vm.isReadOnly,
                              error: errors[0],
                              label: "Condiciones de trabajo Conclusiones:",
                              maxlength: 5000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.workingConditionsConclusions,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "workingConditionsConclusions",
                                  $$v
                                )
                              },
                              expression: "model.workingConditionsConclusions"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2904845466
                )
              })
            : _c("div", { staticClass: "d-flex flex-column" }, [
                _c(
                  "label",
                  {
                    staticClass: "text-muted",
                    staticStyle: { "font-size": "14px" }
                  },
                  [_vm._v(" Condiciones de trabajo Conclusiones: ")]
                ),
                _c("span", [
                  _vm._v(_vm._s(_vm.model.workingConditionsConclusions))
                ])
              ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }